import _ from "lodash"
import {validations} from "./validation-rules"

const VALUE_POINTER_MAP = Object.freeze({
    activeTab: "/appstate/activeTab",
    alterKunde: "/kunde/alterKalenderjahr",
    gebDatumKunde: "/kunde/geburtsdatum",
    gebDatumPartner: "/ehepartner/geburtsdatum",
    alterEhepartner: "/ehepartner/alterKalenderjahr",
    von: "/appstate/zeitraum/von",
    bis: "/appstate/zeitraum/bis",
    zeitraumArt: "/appstate/zeitraumArt",
    kinder: "/kinder"
})

const buildValidationsForArray = (values, item, getDataFromPointer) => {
    return (values[item.arrayKey] ?? []).map((element, index) => ({
        errorPointer: item.errorPointer(index),
        message: item.message?.(index) ?? item.message,
        severity: item.severity,
        validationResult: item.validator(element, getDataFromPointer)
    }))
}

const shouldToast = (errorPointer, validationResult, getDataFromPointer) => validationResult && !getDataFromPointer(errorPointer)

export const validate = (getDataFromPointer, updateData) => {
    const values = _.mapValues(VALUE_POINTER_MAP, getDataFromPointer)
    validations
        .flatMap(item => item?.arrayKey
            ? buildValidationsForArray(values, item, getDataFromPointer)
            : [{...item, validationResult: item.validator(values, getDataFromPointer)}])
        .filter(({validationResult, errorPointer}) => validationResult !== getDataFromPointer(errorPointer))
        .forEach(({errorPointer, message, severity, validationResult}) => {
            if(shouldToast(errorPointer, validationResult, getDataFromPointer)) {
                severity(message)
            }
            updateData(validationResult, errorPointer)
        }
    )
}